<template lang="pug">
.mainWrapper-innerContent
  .mainWrapper-leftContent
    BreadCrumb(v-if="info.category" :breadcrumbList='breadcrumbs')
    ArticleStory(:info="info" :staticData="data" :followStatus="followStatus")
    ArticleCommentBlock(:comments="info.comments" :staticData="data" :articleId="info.id")
    TemporaryArticles(
      v-if="isPartner && relatedArticles.length"
      :currentArticleId="currentId"
      :articles="relatedArticles"
      @onRefresh="getSingleArticle"
      :info="info"
    )
    ArticlesInPartnersBlock(
      v-if="info.articleInPartners.length"
      :title="data.articlePage.articleInPartners"
      :partnerLink="info.articleInPartners"
      :style="{paddingTop: '24px'}"
    )
  .mainWrapper-rightContent
    .sidebar--right
      LatestArticlesBlock(
        v-if="!info.category"
        :title='data.articlePage.sectionTextRelatedArticle'
        type="latestArticlesByCategory"
        :params='params'
        :staticData='data.latestArticles'
      )
      RelatedArticlesBlock(
        v-if="info.category"
        :title='data.articlePage.sectionTextRelatedArticle'
        type="recommendArticleByContent"
        :params='params'
        :staticData='data.latestArticles'
      )
</template>
<script>
import BreadCrumb from '@/components/modules/breadcrumb/breadcrumb.vue';
import ArticleStory from '@/components/modules/article_story/article_story.vue';
import ArticleCommentBlock from '@/components/article_comment/article_comment_block.vue';
import LatestArticlesBlock from '@/components/latest_articles/latest_articles_block.vue';
import RelatedArticlesBlock from '@/components/latest_articles/related_articles_block.vue';
import ArticlesInPartnersBlock from '@/components/temporaryArticles/article_in_partners_block.vue';
import TemporaryArticles from '@/components/temporaryArticles/TemporaryArticles.vue';
import { getFollowArticleIds } from '@/plugins/api.js';
import { setGtag } from '@/plugins/gtag.js';
import { getCategoryNameById } from '@/plugins/tool.js';

export default {
  props: {
    data: Object
  },
  components: {
    BreadCrumb,
    ArticleStory,
    ArticleCommentBlock,
    ArticlesInPartnersBlock,
    LatestArticlesBlock,
    RelatedArticlesBlock,
    TemporaryArticles
  },
  computed: {
    isPartner() {
      return this.identity === 'partners';
    },
    currentId() {
      return this.info.id ? this.info.id.toString() : '';
    },
    relatedArticles() {
      const esArticles = this.info.esArticles || [];
      const childArticles = (this.info.childArticles || []).map(a => {
        a.isChild = true;
        return a;
      });
      return [...esArticles, ...childArticles];
    }
  },
  data() {
    let urlQuery = this.$route.query;
    return {
      id: urlQuery.articleId,
      breadcrumbs: [{ text: '首頁', link: '/' }],
      info: {
        comments: [],
        tag: {},
        esArticles: [],
        childArticles: []
      },
      params: {
        categoryId: urlQuery.categoryId,
        id: urlQuery.articleId,
        size: 6
      },
      followIds: [],
      followStatus: false,
      token: localStorage.getItem(this.$store.state.storageKeys.token),
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    };
  },
  async created() {
    await this.getSingleArticle();
    const link = {
      path: '/category',
      query: {
        type: 'recommendArticleByContent',
        id: this.info.id
      }
    };
    this.breadcrumbs.push({
      text: getCategoryNameById(this.$route.query.categoryId, this.$store.state.lang) + '話題',
      link: link
    });
  },
  methods: {
    async getSingleArticle() {
      let route, res;
      if (this.identity == 'partners') {
        route =
          this.$store.state.URLs.apiPartner +
          this.$store.state.routes.getSingleArticle +
          '/' +
          this.id;
        res = await this.$axios
          .get(route, {
            headers: {
              'X-Line-Biz-Session': localStorage.getItem(
                this.$store.state.storageKeys.token
              )
            }
          })
          .catch(() => this.$router.push('/'));
      } else {
        route =
          this.$store.state.URLs.api +
          '/' +
          this.$store.state.lang +
          this.$store.state.routes.getSingleArticle +
          '/' +
          this.id;
        res = await this.$axios.get(route).catch(() => this.$router.push('/'));
      }
      this.trackInfo(this.info, res.data);
      this.info = res.data;
      if (this.token) {
        let followIds = await getFollowArticleIds(
          this.$store.state,
          this.$axios
        );
        if (followIds && followIds.includes(this.info.id))
          this.followStatus = true;
        else this.followStatus = false;
      }
    },
    trackInfo(oldInfo, newInfo) {
      if (!newInfo) return;
      const { id, content } = newInfo;
      const trackingContent = (content || '').substring(0, 200);
      setGtag('view', 'article', trackingContent, 1, !id || id === oldInfo.id);
      setGtag('view-ga4', 'article', id + ' : ' + trackingContent, 1, !id || id === oldInfo.id);
    }
  }
};
</script>
